import scrollTo from "../utils/scrollto";

function anchorLink(el) {
	const target = document.querySelector(el.getAttribute('data-js-scroll-to'));

	target && el.addEventListener(
		'click',
		evt => {
			evt.preventDefault();
			scrollTo(target);
		}
	)
}

function init() {
	const links = [...document.querySelectorAll('[data-js-scroll-to]')];

	links.forEach(
		link => anchorLink(link)
	);
}

init();
